// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getDatabase } from "firebase/database";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyD3UtWQ1IBC6i3G-1fgefiVJcPMLvfXuws",
  authDomain: "paymenthub-6f141.firebaseapp.com",
  databaseURL:
    "https://paymenthub-6f141-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "paymenthub-6f141",
  storageBucket: "paymenthub-6f141.appspot.com",
  messagingSenderId: "223925630250",
  appId: "1:223925630250:web:3659844640b3ed4fde9a53",
  measurementId: "G-1187164YHQ",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
getAnalytics(app);
const auth = getAuth(app);
const db = getFirestore(app);
const database = getDatabase(app);

export { auth, db, app, database };
